var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-feedback-reaction',{ref:"feedbackReaction",attrs:{"labels":_vm.schema.emojiLabels,"value":_vm.value},on:{"input":_vm.parseNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }